import api from 'api';

export const loadMarketingPlan = api(
  'GET /api/marketing-planning/:year/:month'
);

export const saveNodesMarketingPlan = api(
  'PUT /api/marketing-planning/:year/:month/nodes'
);

export const createNodesMarketingPlan = api(
  'POST /api/marketing-planning/:year/:month/nodes'
);

export const removeNodeMarketingPlan = api(
  'DELETE /api/marketing-planning/:year/:month/nodes/:id'
);

export const loadMetaMarketingPlan = api(
  'GET /api/marketing-planning/:year/:month/meta'
);

export const loadAllMetricTypes = api('GET /api/marketing-planning/metrics');

export const saveMetricTypesMarketingPlan = api(
  'PUT /api/marketing-planning/:year/:month/metrics'
);

export const saveActivityTypesMarketingPlan = api(
  'PUT /api/marketing-planning/:year/:month/activitytypes'
);

export const discardMarketingPlan = api(
  'POST /api/marketing-planning/:year/:month/discard'
);

export const saveDraftMarketingPlan = api(
  'POST /api/marketing-planning/:year/:month/draft'
);

export const finalizeMarketingPlan = api(
  'POST /api/marketing-planning/:year/:month/finalize'
);

export const uploadNodesMarketingPlan = ({
  year,
  month,
  parentId,
  file,
  levelPath,
}) => {
  const [
    ,
    network = '-',
    application = '-',
    channel = '-',
    platform = '-',
    affiliate = '-',
    country = '-',
    manager = '-',
  ] = levelPath.replace(/nodes\[(\d+)\]\.*/g, (_, id) => `/${id}`).split('/');

  return api(
    `POST /api/marketing-planning/${year}/${month}/nodes/${parentId}/csv/${network}/${application}/${channel}/${platform}/${affiliate}/${country}/${manager}`
  )(file);
};

export const exportNodesMarketingPlan = api(
  'GET /api/marketing-planning/:year/:month/nodes/:parentId/csv',
  {
    responseType: 'blob',
  }
);
